export default __webpack_public_path__ + "static/media/github.c914ba55.svg";